import { PageLoader } from "./Loader";

/**
 * What a route shows while its lazy chunk is still arriving.
 *
 * Deliberately a content-area spinner rather than a full-screen overlay: this
 * renders inside the app shell, so the rail and header stay put and only the
 * page being navigated to is pending.
 */
export function RouteFallback() {
  return (
    <div className="flex min-h-[40vh] items-center justify-center">
      <PageLoader />
    </div>
  );
}
